export default function PartnersSection() {
  const partners = [
    { name: "SPM Middle East Gold L.L.C.", logo: "/images/spm-logo.svg" },
    { name: "SAFE PENSION", logo: "/images/safepension-logo.png" },
    { name: "SWM AG", logo: "/images/swm-logo.png", subtitle: "seit 1947" },
  ];

  return (
    <section
      data-testid="partners-section"
      className="py-20 sm:py-24 bg-[#12202f] relative"
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#3A4F60]/50 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <p className="uppercase text-xs tracking-[0.25em] text-[#C5993A] mb-4">
          Partnerschaften
        </p>
        <h2 className="font-heading text-2xl sm:text-3xl tracking-tight font-light text-white mb-4">
          VMBS UG ist Exklusivpartner von
        </h2>

        <div
          data-testid="partners-grid"
          className="flex flex-wrap items-center justify-center gap-12 lg:gap-16 mt-12"
        >
          {partners.map((partner) => (
            <div
              key={partner.name}
              data-testid={`partner-${partner.name.split(" ")[0].toLowerCase()}`}
              className="flex flex-col items-center gap-3 group"
            >
              <div className="bg-white/5 border border-[#3A4F60]/30 rounded-lg p-6 hover:border-[#C5993A]/30 transition-all duration-300 flex items-center justify-center h-28 w-52">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-20 max-w-[180px] w-auto object-contain opacity-90 group-hover:opacity-100 transition-opacity"
                />
              </div>
              <span className="text-[#8899AA] text-xs tracking-wider">
                {partner.name}
                {partner.subtitle && (
                  <span className="block text-[#C5993A]">{partner.subtitle}</span>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
